<template>
  <div class="w-full relative mb-1">
    <img
      :src="getAssetUrl(review.petPhoto)"
      :alt="$t('ppc-landing.pet-photo-alt')"
      class="absolute top-0 left-1/2 md:left-0 transform -translate-x-1/2 md:translate-x-0 md:translate-y-0 w-20 md:w-36 rounded-2xl md:rounded-3xl z-10"
    />
    <div class="relative h-fit min-h-64 bg-white p-10 text-left rounded-3xl shadow mt-12 md:mt-16 md:ml-16 z-0 md:z-10">
      <div class="flex gap-x-1">
        <fa
          v-for="i in 5"
          :key="i"
          :icon="['fas', 'star']"
          class="text-bubblegum size-4"
        />
      </div>
      <p class="mt-2 text-neutral-900 font-bold">
        {{ review.author }}
      </p>
      <p class="mt-6 text-neutral-900 line-clamp-[4]">
        {{ review.review }}
      </p>
    </div>
  </div>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterPPCReviewCard',

  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getAssetUrl,
  },
};
</script>
